import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { Page,  selectPages, PageForm, toPageForm } from './pageSlice';
import { usePageQuery, usePageSaveMutation } from '../../api/page';
import MDViewer from '../markdown/Markdown';
import Metadata from '../metadata/Metadata';
import PageEditToolBar from './PageEditToolBar';
import PageEditForm from './PageEditForm';

export interface SerializedError {
	name?: string
	message?: string
	stack?: string
	code?: string
}

const vcontentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	display: 'flex',
	//backgroundColor: 'grey',
};
const contentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	//overflow: 'auto',
	display: 'flex',
	//backgroundColor: 'grey',
};
const colOneStyle = {
	height: '100%',
	flexGrow: 3,
	width: '75%',
	//backgroundColor: '#eeeeee',
	//overflow: 'auto',
};
const colTwoStyle = {
	height: '100%',
	flexGrow: 1,
	//backgroundColor: 'green',
	width: '25%',
	//overflow: 'auto',
};
const viewStyle = {
	height: `calc(100% - 44px)`,
	overflow: 'auto',
	padding: 2,
	width: '100%',
	//height: '100%r',
	//backgroundColor: 'purple',
};

export function PageEdit() {
	let {pageId} = useParams();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	console.log("202409051528", pageId, isMobile);
	if (pageId) {
		if (isMobile) {
			return ( <PageViewerFetch pageId={pageId} /> )
		} else {
			return ( <PageViewerFetch pageId={pageId} /> )
		}
	} else {
		if (isMobile) {
			return ( <PageViewerContent page={null} /> )
		} else {
			return ( <PageViewerContent page={null} /> )
		}
	}
}

export function PageViewerFetch( {pageId}: {pageId: string}) {
	const dispatch = useAppDispatch();
	const {
		data: pageResult,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = usePageQuery(pageId, { refetchOnMountOrArgChange: true});
	return (
		<>
		{
			error
				? (<PageViewerProblem error={error} isLoading={isLoading} />)
				: isLoading
					? ( <PageViewerProblem error={error} isLoading={isLoading} /> )
					: pageResult
						? pageResult.page
							? ( <PageViewerContent page={pageResult.page} /> )
							: ( <PageViewerProblem error={error} isLoading={isLoading} /> )
						: null

		}
		</>
	);
}

export function PageViewerContent( {page}: {page: Page | null}) {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	let [pf, setPF] = React.useState(toPageForm(page));
	const onPFChange = (pf: PageForm) => {
		setPF(pf);
	}
	const [
		pageSave,
		{ data: data, isLoading: isUpdating, isSuccess: isSuccess }
	] = usePageSaveMutation()
	const onPost = () => {
		console.log("202410060859", pf);
		pageSave(pf).unwrap().then(fullfilled => {
			console.log("202412311241", isSuccess, fullfilled);
			if (fullfilled && fullfilled.page) {
				navigate("/page/view/" + fullfilled.page.metadata.id);
			}
		});
	}
	return (
		<Box sx={vcontentStyle}>
			<Box><PageEditToolBar page={page} onPost={onPost}/></Box>
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						<PageEditForm
						pf={pf}
					   	onPFChange={onPFChange} />
					</Box>
				</Box>
				<Box sx={colTwoStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
							{page &&
						<Box>
							<Metadata meta={page.metadata}/>
							ktype: {page.ktype}
						</Box>
							}
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export function PageViewerProblem( {isLoading, error}: {
	error: FetchBaseQueryError | SerializedError | undefined,
   	isLoading: boolean,
} ) {
	const dispatch = useAppDispatch();

	return (
		<Box sx={vcontentStyle}>
			<PageEditToolBar page={null} onPost={() => {}} />
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						{
							error
								? ( <Box>error</Box> )
								: isLoading
									? ( <Box>Loading</Box> )
									: ( <Box>No Ressource</Box> )
						}
					</Box>
				</Box>
				<Box sx={colTwoStyle}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						{
							error
								? (	<Box>error</Box> )
								: isLoading
									? ( <Box>Loading</Box> )
									: null
						}
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

function testErrorType(error: FetchBaseQueryError | SerializedError) {
	console.log(error);
}
